import React from "react";

export default function App() {
  // Récupère la date du jour au format AAAA-MM-JJ
  const today = new Date();
  const dateStr = today.toISOString().slice(0, 10); // ex: "2025-09-23"

  // Construit le chemin vers l'image
  const imagePath = `/photos/${dateStr}.png`;

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Bonjour Claude 👋</h1>
      <p>Photo du jour : {dateStr}</p>
      <img
        src={imagePath}
        alt={`Claude du ${dateStr}`}
        style={{ maxWidth: "400px", borderRadius: "20px", boxShadow: "0 4px 12px rgba(0,0,0,0.2)" }}
        onError={(e) => {
          e.target.src = "/photos/default.jpg"; // s'il n'y a pas de photo prévue
        }}
      />
      <p>Cause we all need a Claude in our life</p>
    </div>
  );
}

